import React, { useEffect } from "react";
import styled from "styled-components";
import * as Scroll from "react-scroll";
import {
  Switch,
  Route,
  // useParams,
  useRouteMatch,
  useLocation,
} from "react-router-dom";
import parse from "html-react-parser";
import { Typography } from "@material-ui/core";
import { Banner, Card, BeritaTerbaru } from "../../components";
import Context from "../../context";

const scroll = Scroll.animateScroll;

const StyledBody = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 40px;
  margin: 0 16px;
  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
`;

const StyledSidebar = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  @media screen and (max-width: 500px) {
    width: 100%;
  }
`;

const StyledBorder = styled.div`
  border-left: 1px solid #d4d4d4;
  margin: 0 40px;
  @media screen and (max-width: 800px) {
    margin-left: 16px;
    margin-right: 32px;
  }
  @media screen and (max-width: 500px) {
    display: none;
  }
`;

const StyledContent = styled.div`
  width: 100%;
  max-width: 650px;
  padding-top: 16px;
  @media screen and (max-width: 500px) {
    padding-top: 32px;
  }
`;

const DetailDisekitarKami = ({ data, isId }: any) => {
  const { title_id, title_en, content_id, content_en, image } = data;

  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <>
      <Typography
        variant="h4"
        color="primary"
        style={{ marginBottom: "2rem" }}
        gutterBottom
      >
        {isId ? title_id : title_en}
      </Typography>
      <img
        style={{ width: "100%" }}
        src={`${process.env.REACT_APP_URL}/images/${image}`}
        alt={isId ? title_id : title_en}
      />

      <div id="content" style={{ marginTop: "1rem" }}>
        {parse(isId ? content_id : content_en)}
      </div>
    </>
  );
};

const DisekitarKami = () => {
  const location = useLocation();
  const context = React.useContext(Context);
  const currentLang = context.getLang();
  const isId = currentLang === "ID";
  const { path } = useRouteMatch();
  return (
    <>
      <Banner title={isId ? "Disekitar Kami" : "Around Us"} />
      <StyledBody>
        <StyledSidebar>
          <Card title={isId ? "Berita Terbaru" : "Latest News"}>
            <BeritaTerbaru />
          </Card>
        </StyledSidebar>
        <StyledBorder />
        <StyledContent>
          <Switch>
            <Route path={`${path}/:disekitarId`}>
              <DetailDisekitarKami isId={isId} data={location.state} />
            </Route>
          </Switch>
        </StyledContent>
      </StyledBody>
    </>
  );
};

export default DisekitarKami;
